import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderService } from './loader.service';
import { IS_BACKGROUND } from "../api/api-http-context-token";
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  service_count = 0;
  constructor(public loaderService: LoaderService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.context?.get(IS_BACKGROUND) === true){
      return next.handle(req);
    }
    
    this.service_count++;
    this.loaderService.updateRequest(1);
    return next.handle(req).pipe(
      finalize(() => {
        this.service_count--;
        this.loaderService.updateRequest(-1);
      })
    );
  }
}
